export function formatTime(hour: number, minute: number): string {
  const period = hour >= 12 ? "PM" : "AM";

  const displayHour = hour % 12 === 0 ? 12 : hour % 12;

  const displayMinute = minute === 0 ? "" : `:${minute}`;

  return `${displayHour}${displayMinute} ${period}`;
}

export default formatTime;

